import t from"./_getMapData.js";function a(a){return t(this,a).get(a)}export{a as default};
//# sourceMappingURL=_mapCacheGet.js.map
